import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { getAllLastSeen, getAllUsers } from "../services/api";
import CustomButton from "./common/CustomButton";
import { v4 as uuidv4 } from "uuid";
import { truncateWithTooltip } from "../helpers/common";

function AllLastSeen(props) {
  const { fileId } = props;
  const [usersViewed, setUsersViewed] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [userHaventSeen, setUserHaventSeen] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // getLastSeen(fileId, userId, setLastSeen);
    getAllUsers(setAllUsers);
    getAllLastSeen(fileId, setUsersViewed);
  }, []);

  function getUserWithNoLastSeen(user) {
    for (let x = 0; x < usersViewed.length; x++) {
      if (usersViewed[x].user_id === user.id) return false;
    }
    return true;
  }

  useEffect(() => {
    setUserHaventSeen(allUsers.filter(getUserWithNoLastSeen));
  }, [allUsers, usersViewed]);

  return (
    <>
      <CustomButton
        variant="outline-primary"
        style={{ padding: 0, margin: 0, width: "50px", fontSize: "14px" }}
        onClick={() => setShowModal(true)}
      >
        Track
      </CustomButton>
      <Modal
        style={{ marginTop: "10vh" }}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            width: "100%",
            height: "80vh",
            minHeight: "50vh",
            padding: "20px",
            color: "#0f4c8f",
            overflowY: "scroll",
          }}
        >
          <div>
            <p style={{ fontWeight: "bold", fontSize: "20px" }}> Unread:</p>
            {userHaventSeen.map((e) => (
              <div key={uuidv4()}>
                {truncateWithTooltip(`${e.first_name}, ${e.last_name}`)}
              </div>
            ))}
          </div>
          <div>
            <p style={{ fontWeight: "bold", fontSize: "20px" }}>Read:</p>
            {usersViewed.map((e) => (
              <div key={uuidv4()}>
                {truncateWithTooltip(`${e.first_name}, ${e.last_name}`)}
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AllLastSeen;
